import {
  CONSTRAINTS_SET_DEFAULTS,
  CONSTRAINTS_SET_MINIMUMS,
  CONSTRAINTS_SET_MAXIMUMS
} from "../lib/types";
import { getScaledValue } from "../lib/calculations";

export const setConstraints = ( chamberType, hasUnderdrain, setDefaults ) => ( dispatch, getState ) => {
  try {
    const { globals } = getState();
    const { scalePixels, scaleValue } = globals;

    const _getScaledValue = getScaledValue.bind(null, scalePixels, scaleValue);

    const CONSTRAINTS = window._bridge === undefined ? chamberType.webConstraints : chamberType.appConstraints;

    const getConstraints = ( constraintKey ) => {
      let result = {};
      Object.keys(CONSTRAINTS).forEach(param => result[param] = CONSTRAINTS[param][constraintKey]);
      return result;
    };

    let defaults = getConstraints("default");
    let minimums = getConstraints("min");
    let maximums = getConstraints("max");

    [defaults, minimums, maximums]
      .forEach(list => {
        if (hasUnderdrain) list["availableWidth"] = list["availableWidthWithUnderdrain"];
        list["chamberRowSpacing"] /= 12;
        list["chamberRowSpacingPixels"] = _getScaledValue(list["chamberRowSpacing"]);
        delete list["availableWidthWithUnderdrain"];
      });

    if (setDefaults) {
      dispatch({
        type: CONSTRAINTS_SET_DEFAULTS,
        payload: defaults
      });
    }

    dispatch({
      type: CONSTRAINTS_SET_MINIMUMS,
      payload: minimums
    });

    dispatch({
      type: CONSTRAINTS_SET_MAXIMUMS,
      payload: maximums
    });
  } catch (exception) {
    console.warn("Unable to retrieve constraints");
  }
};



// WEBPACK FOOTER //
// ./src/actions/constraints-actions.js